export const HORIZONTAL_ORIENTATION = -90;
export const VERTICAL_ORIENTATION = 0;

export const EDITOR_TAB_PANEL_ELEMENTS = 'EditorTabPanelElements';
export const EDITOR_TAB_PANEL_INSPECTOR = 'EditorTabPanelInspector';

